import React from "react";
import { Table } from "antd";

const UserAccountsTab = ({ data }) => {
  return (
    <Table
      dataSource={data}
      rowKey={(r) => r.id}
      pagination={false}
      columns={[
        { title: "Acount Type", dataIndex: "account_type_id" },
        { title: "Username", dataIndex: "username" },
        { title: "Role", dataIndex: "role" },
        { title: "Status", dataIndex: "status" },
      ]}
    />
  );
};

export default UserAccountsTab;
